const COMMAND_CREATED = (state, command) => {
  state.command = command
}
const DEVICE_COMMANDS_UPDATED = (state, commands) => {
  // let commands = response.data.data
  // let {data: {data: commands}} = response
  // response.data.map( c => c.attributes )
  console.log('DEVICE_COMMANDS_UPDATED')
  console.log(commands)
  state.commands = commands
}

export default {
  COMMAND_CREATED,
  DEVICE_COMMANDS_UPDATED
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/commands/mutations.js